export default "__VITE_ASSET__Dqpf5pFe__"